import { render, staticRenderFns } from "./thai-edit.vue?vue&type=template&id=69798716&"
import script from "./thai-edit.vue?vue&type=script&lang=js&"
export * from "./thai-edit.vue?vue&type=script&lang=js&"
import style0 from "./thai-edit.vue?vue&type=style&index=0&id=69798716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports